import PageHero from "@/components/sections/PageHero";
import BeforeAfter from "@/components/sections/BeforeAfter";

export default function GaleriePage() {
  return (
    <>
      <PageHero
        eyebrow="/ Galerie"
        title="Avant"
        accent="/ Après"
        description="Glissez le curseur pour comparer la transformation. Le souci du détail, en images."
      />
      <BeforeAfter hideHeader />
    </>
  );
}
